//import axios from "axios";
//import ApiService from "@/services/api.service";
import {
  DeliveryOrderService,
  ReportingServices
} from "@/services/api.service";
import { API_URL } from "@/services/config.service";

const state = {
  do_items: null,
  delivery_order: null,
  jsreport: null,
  report_weekly_sales_count: null,
  do_dashboard_data: null,
  delivery_orders: null,
  sheet_number: null,
  loading: false,
  loading_do_items: false,
  apiUrl: API_URL + "/departed_vessels",
  axiosConfig: {
    headers: {
      "Content-Type": "application/json"
    }
  }
};

const getters = {
  do: state => state.delivery_order,
  do_details: state => state.do_details
};

const mutations = {
  msetDoItems: (state, payload) => (state.do_items = payload),
  //setDoDetails: (state, payload) => (state.do_details = payload),
  msetDO: (state, payload) => (state.delivery_order = payload),
  msetDOs: (state, payload) => (state.delivery_orders = payload),
  msetJSReport: (state, payload) => (state.jsreport = payload),
  msetWeeklySalesCount: (state, payload) =>
    (state.report_weekly_sales_count = payload),
  msetSheetNumber: (state, payload) => (state.sheet_number = payload),
  msetDODashboardData: (state, payload) => (state.do_dashboard_data = payload),
  setLoading: (state, payload) => (state.loading = payload)
};

const actions = {
  fetchDeliveryOrders: async ({ state, commit }) => {
    commit("setLoading", true);
    try {
      const response = await DeliveryOrderService.get();
      commit("msetDOs", response.data.delivery_orders);
      //return response.data.delivery_orders;
    } catch (error) {
      commit("msetDOs", []);
    }
    commit("setLoading", false);
  },

  aGetJSReport: async ({ state, commit }, payload) => {
    //commit("setLoadingDoItems", true);
   // console.log("payload reporting service", payload);
    try {
      const response = await ReportingServices.get_jsreports(
        "do_jsreport",
        payload
      );
      if (response.status === 200) {
        commit("msetJSReport", response.data.jsreport);
        return response;
      }
     // console.log("report html data from store", response);
    } catch (error) {
      commit("msetJSReport", []);
    }
    // commit("setLoadingDoItems", false);
  },

  aGetWeeklySalesCount: async ({ state, commit }, payload) => {
    //  console.log("payload reporting", payload);
    try {
      const response = await ReportingServices.get_weekly_sales_counts(
        "reporting/weekly",
        payload
      );
      if (response.status === 200) {
        commit("msetWeeklySalesCount", response.data.jsreport);
        return response;
      }
      console.log("reporting  data count", response);
    } catch (error) {
      commit("msetWeeklySalesCount", []);
    }
  }
  /*
  asetDeliveryOrder: function({ commit }, payload) {
    commit("msetDO", payload);
    console.log("commit do ", state.delivery_order);
  } */
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
